<template>
  <div style="padding-top: 15px;padding-bottom: 15px;">
    <div class="panel panel-info">
      <div class="panel-heading">
        <h4 class="panel-title">
          <i class="fa fa-book"></i>修改套餐<span
            @click="$router.go(-1)"
            style="cursor: pointer;"
            title="返回"
            class="fa fa-chevron-circle-left pull-right"
            >返回</span
          >
        </h4>
      </div>

      <div class="panel-body">
        <div class="row">
          <div class="modal-body wrapper-lg" style="width:100%">
            <div class="row" style="padding-right:10px">
              <div class="col-sm-12 col-sm-offset-0">
                <form role="form" class="form-horizontal">
                  <div class="form-group">
                    <label class="col-sm-2 control-label"
                      ><span class="required">*</span>套餐名称</label
                    >
                    <div class="col-sm-5">
                      <input
                        type="text"
                        v-model="model.tcmc"
                        name="tcmc"
                        v-validate="{ required: true, max: 50 }"
                        data-vv-as="用户名"
                        class="form-control"
                        placeholder=""
                      />
                      <span class="error_validate_msg"
                        ><em>{{ errors.first("yhm") }}</em></span
                      >
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-2 control-label"
                      ><span class="required">*</span>学历类型</label
                    >
                    <div class="col-sm-5">
                      <select
                        class="form-control"
                        v-model="model.xllx"
                        name="js"
                        v-validate="{ required: true }"
                        data-vv-as="用户角色"
                      >
                        <option value="">--请选择--</option>
                        <option
                          v-for="xllx in xllxArr"
                          :value="xllx.value"
                          :key="xllx.value"
                          >{{ xllx.text }}</option
                        >
                      </select>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-2 control-label"
                      ><span class="required">*</span>报考范围</label
                    >
                    <div class="col-sm-8">
                      <div class="col-sm-8" style="margin-bottom: 20px;">
                        <button
                          type="button"
                          class="btn"
                          @click="toProChoose()"
                        >
                          选择报考范围
                        </button>
                      </div>

                      <div class="col-sm-8" v-if="model.ranges != 0">
                        <table style="backgroundColor:#F5F5F5;">
                          <thead>
                            <tr>
                              <th>主考学校</th>
                              <th>专业层次</th>
                              <th>学科</th>
                              <th>选择专业</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, index) in model.ranges"
                              :key="index + 'a'"
                            >
                              <td>
                                <BootstrapCombobox
                                  :enabled="false"
                                  :data="zkxxArr"
                                  value-field="id"
                                  text-field="jgmc"
                                  v-model="item.zkxxId"
                                  :formatOption="
                                    (zkxx) => zkxx.jgdm + '-' + zkxx.jgmc
                                  "
                                ></BootstrapCombobox>
                              </td>

                              <td>
                                <BootstrapCombobox
                                  :enabled="false"
                                  :data="zyccArr"
                                  value-field="value"
                                  text-field="text"
                                  v-model="item.zycc"
                                  :format-option="(zycc) => zycc.text"
                                  @change="zyccChange(item)"
                                ></BootstrapCombobox>
                              </td>

                              <td>
                                <BootstrapCombobox
                                  :enabled="false"
                                  :data="xkArr"
                                  value-field="id"
                                  text-field="xkmc"
                                  v-model="item.xkId"
                                  :formatOption="
                                    (xk) => xk.xkdm + '-' + xk.xkmc
                                  "
                                  @change="xkIdChange(item)"
                                ></BootstrapCombobox>
                              </td>

                              <td>
                                <BootstrapCombobox
                                  :enabled="false"
                                  :data="item.zyArr"
                                  value-field="id"
                                  text-field="xkmc"
                                  v-model="item.zyId"
                                  :format-option="
                                    (zy) => zy.zydm + '-' + zy.zymc
                                  "
                                ></BootstrapCombobox>
                              </td>
                              <td>
                                <button
                                  type="button"
                                  class="btn "
                                  style="backgroundColor:#FF4500;color:#FFFAFA"
                                  @click="delRanges(index)"
                                >
                                  <span
                                    class="glyphicon glyphicon-trash"
                                    aria-hidden="true"
                                  ></span>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-2 control-label"
                      ><span class="required">*</span>注册范围</label
                    >

                    <div class="col-sm-8">
                      <div class="col-sm-8" style="margin-bottom: 20px;">
                        <button
                          type="button"
                          class="btn"
                          @click="toUserChoose()"
                        >
                          选择注册范围
                        </button>
                      </div>

                      <div class="col-sm-8" v-if="model.regRanges != 0">
                        <table
                          style="width:800px;margin:0 auto;backgroundColor:#F5F5F5;border: 1px soild #696969"
                        >
                          <thead>
                            <tr>
                              <th>套餐限制类型</th>
                              <th>限制类型</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, index) in model.regRanges"
                              :key="index + 'b'"
                            >
                              <td>
                                <BootstrapCombobox
                                  :enabled="false"
                                  :data="xzlxArr"
                                  value-field="value"
                                  text-field="text"
                                  v-model="item.xzlx"
                                  :formatOption="(xzlx) => xzlx.text"
                                  @change="xzlxChange(item)"
                                ></BootstrapCombobox>
                              </td>
                              <td>
                                <BootstrapCombobox
                                  :enabled="false"
                                  :data="item.xzzArr"
                                  value-field="id"
                                  text-field="mc"
                                  v-model="item.xzz"
                                  :formatOption="(xzz) => xzz.mc"
                                ></BootstrapCombobox>
                              </td>
                              <td>
                                <button
                                  type="button"
                                  class="btn "
                                  style="backgroundColor:#FF4500;color:#FFFAFA"
                                  @click="delregRanges(index)"
                                >
                                  <span
                                    class="glyphicon glyphicon-trash"
                                    aria-hidden="true"
                                  ></span>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-2 control-label"
                      ><span class="required">*</span>收费标准</label
                    >
                    <div class="col-sm-10">
                      <table style="backgroundColor:#F5F5F5;">
                        <thead>
                          <tr>
                            <th>收费项目</th>
                            <th>收费金额</th>
                            <th>
                              <button
                                type="button"
                                class="btn "
                                style="backgroundColor:#2E8B57;color:#FFFAFA"
                                @click="add()"
                              >
                                <span
                                  class="glyphicon glyphicon-plus"
                                  aria-hidden="true"
                                ></span>
                              </button>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in model.amounts"
                            :key="index + 'd'"
                          >
                            <td>
                              <select
                                class="form-control"
                                v-model.number="item.sflx"
                                name="js"
                                v-validate="{ required: true }"
                                data-vv-as="用户角色"
                              >
                                <option value="">--请选择--</option>

                                <option
                                  v-for="(sflx, index) in sflxArr"
                                  :value="sflx.value"
                                  :key="index + 'c'"
                                  >{{ sflx.text }}</option
                                >
                              </select>
                            </td>
                            <td>
                              <input
                                type="text"
                                v-model="item.sfje"
                                class="form-control"
                                placeholder=""
                              />
                            </td>
                            <td>
                              <button
                                type="button"
                                class="btn "
                                style="backgroundColor:#FF4500;color:#FFFAFA"
                                @click="del(index)"
                              >
                                <span
                                  class="glyphicon glyphicon-trash"
                                  aria-hidden="true"
                                ></span>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <!--保存-->
          <div class="col-sm-12 text-center">
            <div class="form-group">
              <button
                @click="save()"
                type="button"
                class="btn btn-primary btn-sm "
                style="margin-right:16px"
              >
                提交
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--选择产品范围  -->
    <PackageMgchooseEdit
      ref="PackageMgchooseEdit"
      @sendFwData="sendFwData"
      :modelRanges="model.ranges"
    ></PackageMgchooseEdit>
    <!--选择用户范围  -->
    <PackageMgUserchooseEdit
      ref="PackageMgUserchooseEdit"
      :modelRegRanges="model.regRanges"
      @sendXzfwData="sendXzfwData"
    ></PackageMgUserchooseEdit>
  </div>
</template>
<script>
import PackageMgchooseEdit from "./package-mg-choose-edit";
import PackageMgUserchooseEdit from "./package-mg-userchoose-edit";
import { xllx, sflx, zycc, xzlx } from "@/plugins/enums.js";

export default {
  name: "PackageMgEdit",
  components: {
    PackageMgchooseEdit,
    PackageMgUserchooseEdit,
  },
  data: function() {
    return {
      //主考学校下拉
      zkxxArr: [],
      // 专业层次下拉
      zyccArr: [],
      //  学科下拉
      xkArr: [],
      // 选择专业下拉
      zyArr: [],
      // isShow: false,
      // 收费类型
      sflxArr: [],
      model: {
        tcmc: null,
        xllx: null,
        ranges: [],
        regRanges: [
          {
            xzlx: null,
            xzz: null,
            xzzArr: [],
          },
        ],
        amounts: [
          {
            sflx: null,
            sfje: null,
          },
        ],
      },
      // 学历类型下拉
      xllxArr: [],
      tcId: null,
    };
  },
  async created() {
    this.xllxArr = xllx;
    this.sflxArr = sflx;
    this.model.tcmc = this.$route.query.tcmc;
    this.model.xllx = this.$route.query.xllx;
    this.model.id = this.$route.query.id;
    this.tcId = this.$route.query.id;

    this.zyccArr = zycc;
    this.zkxx();
    this.xk();
    this.xzlxArr = xzlx;

    // 收费标准数据
    let res1 = await this.$http.post("/htgl/biz/cw/tc/sfbz/getByTcId", {
      tcId: this.$route.query.id,
    });
    if (res1) {
      this.model.amounts = res1.data;
    }
    // 报考范围
    let res2 = await this.$http.post("/htgl/biz/cw/tc/bkfw/getByTcId", {
      tcId: this.$route.query.id,
    });
    if (res2) {
      this.model.ranges = res2.data;
      this.model.ranges.forEach((li, m) => {
        this.xzlxChange(li);
        this.xkIdChange(li);
      });
    }

    // 报考范围
    let res3 = await this.$http.post("/htgl/biz/cw/tc/zcfw/getByTcId", {
      tcId: this.$route.query.id,
    });
    if (res3) {
      this.model.regRanges = res3.data;
      this.model.regRanges.forEach((li, m) => {
        this.xzlxChange(li);
        this.xkIdChange(li);
      });
    }
  },
  methods: {
    zyccChange(item) {
      this.$http
        .post("/htgl/inf/zy/cx", {
          zycc: item.zycc,
          xkId: item.xkId,
        })
        .then((res) => {
          item.zyArr = res.data.records;
        });
    },

    xkIdChange(item) {
      this.$http
        .post("/htgl/inf/zy/cx", {
          zycc: item.zycc,
          xkId: item.xkId,
        })
        .then((res) => {
          item.zyArr = res.data.records;
        });
    },
    xzlxChange(item) {
      let poUrl = "/htgl/biz/cw/tc/limit";
      this.$http.post(poUrl, { xzlx: item.xzlx }).then((res) => {
        item.xzzArr = res.data;
      });
    },
    sendXzfwData(e) {
      this.model.regRanges = [...this.model.regRanges, ...e];
    },
    // 报考范围
    sendFwData(e) {
      this.model.ranges = [...this.model.ranges, ...e];
    },
    delRanges(index) {
      this.model.ranges.splice(index, 1);
    },
    delregRanges(index) {
      this.model.regRanges.splice(index, 1);
    },

    // 选择专业下拉
    zy() {
      this.$http.post("/htgl/inf/zy/cx", { size: 9999 }).then((res) => {});
    },

    // 学科下拉数据
    xk() {
      this.$http.post("/htgl/inf/xk/cx", { size: 9999 }).then((res) => {
        this.xkArr = res.data.records;
      });
    },
    // 主考学校下拉数据
    zkxx() {
      this.$http
        .post("/htgl/sys/jg/cx", { jglx: "ZKXX", size: 9999 })
        .then((res) => {
          this.zkxxArr = res.data.records;
          console.log;
        });
    },

    // 删除
    del(index) {
      this.model.amounts.splice(index, 1);
    },
    //  点击添加
    add() {
      let obj = {
        sflx: null,
        sfje: null,
      };
      this.model.amounts.push(obj);
    },
    //选择注册范围
    toUserChoose() {
      this.$refs.PackageMgUserchooseEdit.open();
    },
    //选择产品范围
    toProChoose() {
      this.$refs.PackageMgchooseEdit.open();
    },
    reset: function() {
      this.model = {
        tcmc: null,
        xllx: null,
        ranges: [],
        regRanges: [],
        amounts: [
          {
            sflx: null,
            sfje: null,
          },
        ],
      };
    },

    close: function() {
      this.$refs.dialog.close();
    },
    afterClose: function() {
      this.$validator.reset();
      this.reset();
    },

    save() {
      let flag1 = false;
      let flag2 = false;
      let flag3 = false;
      if (this.model.regRanges.length == 0) {
        this.$error("请把注册范围信息补充完整");
      } else {
        flag1 = true;
      }

      if (this.model.regRanges.length == 0) {
        this.$error("请把注册范围信息补充完整");
      } else {
        flag2 = true;
      }

      if (this.model.ranges.length == 0) {
        this.$error("请把报考范围信息补充完整");
      } else {
        flag3 = true;
      }

      this.model.amounts.forEach((item) => {
        if (item.sflx == null || item.sfje == null) {
          this.$error("请把收费信息补充完整");
        } else {
          flag2 = true;
        }
      });
      if (flag1 && flag2 && flag3) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            let poUrl = "/htgl/biz/cw/tc/update";
            this.$http
              .post(poUrl, JSON.stringify(this.model), {
                "Content-Type": "application/json;charset=UTF-8",
              })
              .then((res) => {
                if (res.code == 0) {
                  this.$success("操作成功", () => {
                    this.$router.push({ name: "PackageMg" });
                  });
                }
              });
          }
        });
      }
    },
  },
};
</script>
<style scoped>
th,
td {
  height: 25px;
  padding: 5px 10px;
  line-height: 25px;
}
</style>
